import ReactGA from 'react-ga4'

declare global {
    interface Window {
        GA?: typeof ReactGA
    }
}

/**
 * Whether GA should be enabled.
 * REACT_APP_GA_ID must be set and not "disabled".
 */
export const isGAEnabled = Boolean(process.env.REACT_APP_GA_ID && process.env.REACT_APP_GA_ID !== 'disabled')

/**
 * Initialize Google Analytics 4 (only once).
 * Assigns the ReactGA module to window.GA for global access.
 */
export function initGoogleAnalytics() {
    const trackingId = process.env.REACT_APP_GA_ID

    if (!isGAEnabled || !trackingId) {
        console.warn('GA disabled – REACT_APP_GA_ID is missing or set to "disabled".')
        return
    }

    ReactGA.initialize(trackingId)
    window.GA = ReactGA
    console.info(`GA4 initialized with ID ${trackingId}`)
}
